<script>
import { Line } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'

export default {
  extends: Line,
  props: ['height','chartData','ckey'],
  watch:
  {
    'chartData':function(){
      this.drawChart()
    }
  },
  mouted()
  {
    this.drawChart()
  },
  methods:
  {
    drawChart(){
      const date = []
      const data1 = []
      const data2 = []
      const data3 = []
      const label = []
      for (const [i, k] of this.chartData.entries())
      {
        label.push(k.product_name)  
        if (k.brand_name == "vivo")        
          for(const x of k.timeline)           
            data1.push(this.$options.filters.format(x[this.ckey]))
        else if (k.brand_name == "realme")
          for(const x of k.timeline) 
            data2.push(this.$options.filters.format(x[this.ckey]))
        else if (k.brand_name == "redmi")
          for(const x of k.timeline)
          {
            data3.push(this.$options.filters.format(x[this.ckey]))
            date.push(x['date'])  
          }
      }

      this.renderChart({
        labels: date,
        datasets: [
          {
            label: label[0].toUpperCase(),
            backgroundColor: 'transparent',
            borderColor: '#0072ba',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data1
          },
          {
            label: label[1].toUpperCase(),
            backgroundColor: 'transparent',
            borderColor: '#f56628',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data2
          },
          {
            label: label[2].toUpperCase(),
            backgroundColor: 'transparent',
            borderColor: '#f3b821',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: data3
          }
        ]
      }, {
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          line: {
              tension: 0.00001,
              borderWidth: 1
            },
            point: {
              radius: 1,
              hitRadius: 10,
              hoverRadius: 4
            }
        }
      })
    }
  }
}
</script>
